import { type CatalogPermissionUserConfigConstructor } from '@webapp/modules/purchasing/entities/CatalogPermissionUserConfig'
import { type CatalogPermissionUserConfigApiModel } from '../api-models/CatalogPermissionUserConfigApiModel'

export const mapCatalogPermissionUserConfigApiModel = (
  apiModel: CatalogPermissionUserConfigApiModel
): CatalogPermissionUserConfigConstructor => {
  const fullName =
    `${apiModel.firstName} ${apiModel.lastName}`.trim() || apiModel.email

  return {
    id: apiModel.id,
    fullName,
    email: apiModel.email,
    grantedSecondaryCategoryIds: apiModel.list.map((dept) => dept.id),
  }
}
